const CI = {
	create: (tagname = 'div', args = {}) => {
		return Object.assign(document.createElement(tagname), args)
	},
	getCart: async () => {
		return await (await fetch('/cart.js')).json();
	},
	getProduct: async handle => {
		return await (await fetch(`/products/${handle}.js`)).json();
	},
	now: async () => {
		try {
			const { headers } = await fetch('/cart.js');
			const gmt = [...headers].filter(e => e[0] === 'date');
			return new Date(gmt[0][1]);
		} catch (err) {
			return new Date();
		}
	}
};

class customProductTags {
	limit = `20`;
	offset = `14`;
	sections = {};

	constructor() {
		this.limit = +this.limit;
		this.offset = +this.offset;

		for (const e of [...document.querySelectorAll('.custom-product-tags')]) {
			const { section } = e.dataset;
			if (this.sections?.[section] === undefined) {
				this.sections[section] = e.closest(`[id*="${section}"]`)
			}
		}

		CI.now().then(now => {
			this.now = new Date(now);
			for (const [key, section] of Object.entries(this.sections)) {
				this.setNew(section);
			}
		});
	};

	async setNew(section) {
		[...section.querySelectorAll('.custom-product-tags')].map((e, i) => {
			const { data, sort, template } = e.dataset;
			const diff = new Date(data);
			diff.setDate(diff.getDate() + this.offset);

			if (!template.includes('collection') && diff > this.now) {
				e.prepend(CI.create('li', { className: 'new' }));
				return;
			}

			const param = new URLSearchParams(location.search);
			const paged = param.get('page') || 1;
			if (template.includes('collection') && sort === 'created-descending' && diff > this.now && paged == 1 && i < this.limit) {
				e.prepend(CI.create('li', { className: 'new' }));
			}
		});
	};
};

class bundledControl {
	str = {
		label: `商品区分`,
		preorder: `予約商品`,
		regular: `通常商品`,
		msg: `同梱不可の商品がカート内にあります。`,
	};

	constructor() {
	};

	async init(id, handle, str) {
		Object.assign(this.str, str);

		this.form = document.querySelector(`form[id*="${id}"]`);
		this.form.__handle = handle;

		const input = CI.create('input', { name: `properties[${this.str.label}]`, type: 'hidden', value: this.str.regular });
		this.form.append(input);

		const product = await CI.getProduct(handle);
		for (const tag of product.tags) {
			if (tag === '予約商品') {
				input.value = this.str.preorder;
			}
		}
	};

	async submit(cart) {
		const product = await CI.getProduct(this.form.__handle);
		let product_has_preorder = false;
		for (const tag of product.tags) {
			if (tag === '予約商品') {
				product_has_preorder = true;
			}
		}

		let err = 0;

		for (const item of cart.items) {
			if (
				(product_has_preorder === true && item.handle !== product.handle) ||
				(product_has_preorder === false && item.properties?.[this.str.label] === this.str.preorder)
			) {
				err++;
			}
		}

		if (err > 0) {
			alert(this.str.msg);
			return true;
		}

		return false;
	};

	checkout(cart) {
		const cart_has_preorder = cart.items.filter(item => item.properties?.[this.str.label] === this.str.preorder);
		const cart_has_regular = cart.items.filter(item => {
			return item.properties?.[this.str.label] === this.str.regular || item.properties?.[this.str.label] === undefined
		});

		if (cart_has_preorder.length > 0 && cart_has_regular.length > 0) {
			alert(this.str.msg);
			return true;
		}

		return false;
	};
};

class purchaseLimit {
	str = {
		label: `購入可能数`,
		msg: `購入可能な数が上限に到達しているためカートに入れることができません。
購入可能数：%l`
	};

	constructor() {
	};

	async init(id, handle, str) {
		Object.assign(this.str, str);

		this.form = document.querySelector(`form[id*="${id}"]`);
		this.form.__handle = handle;
		this.form.__limit = null;

		const product = await (await fetch(`${handle}.js`)).json();
		for (const tag of product.tags) {
			if (tag.includes('制限する購入数')) {
				this.form.__limit = +tag.replace('制限する購入数：', '');
			}
		}

		if (this.form.__limit !== null) {
			const input = CI.create('input', { name: `properties[${this.str.label}]`, type: 'hidden', value: this.form.__limit });
			this.form.append(input);
		}
	};

	async submit(cart) {
		if (this.form.__limit === null) {
			return false;
		}
		let qty = +(this.form.closest('.shopify-section').querySelector('[name="quantity"')?.value || 1);
		for (const item of cart.items) {
			if (item.handle === this.form.__handle) {
				qty += item.quantity;
			}
		}

		if (qty > this.form.__limit) {
			alert(this.str.msg.replace('%l', this.form.__limit));
			return true;
		}

		return false;
	};

	async changeQty(wrapper, qty) {
		const input = wrapper.querySelector('[name="updates[]"]');
		if (!input) return false;
		const id = input.dataset.id.split(':')[0];

		const { items } = await CI.getCart();
		const item = items.filter(item => item.id == id && item.properties?.[this.str.label] !== undefined)[0] || null;
		if (item === null) {
			return false;
		}

		let count = qty || 0;
		for (const e of items) {
			if (e.handle !== item.handle || e.id === item.id) {
				continue;
			}
			count += e.quantity;
		}

		const limit = items[0].properties?.[this.str.label];
		if (count > limit) {
			alert(this.str.msg.replace('%l', limit));
			document.dispatchEvent(new CustomEvent('cart:build'));
			return true;
		}
		return false;
	};

	checkout(cart) {
		for (const { handle, properties } of cart.items) {
			if (properties?.[this.str.label] === undefined) {
				continue;
			}

			let qty = 0;
			for (const item of cart.items) {
				if (item.handle === handle) {
					qty += item.quantity;
				}
			}

			if (qty > properties[this.str.label]) {
				alert(this.str.msg.replace('%l', properties[this.str.label]));
				return true;
			}
		}

		return false;
	};
};

class freeShipping {
	amount = '15000';
	cart = {};
	count = 0;
	msg = 'あと****で送料無料';
	success_msg = '送料無料です。';
	target = null;

	constructor() {
		if ('true' === 'false') {
			return;
		}

		this.amount = +this.amount * 100;

		const isCheckVariable = async () => {
			const flg = setTimeout(isCheckVariable, 100);
			if (this.count > 30) {
				clearTimeout(flg);
				return;
			}
			if (DoublyGlobalCurrency?.currentCurrency === undefined) {
				this.count++;
				return;
			}

			clearTimeout(flg);

			this.target = document.querySelector('[data-shipping-free]') || null;
			if (this.target === null) {
				return;
			}

			this.cart = await (await fetch('/cart.js')).json();
			this.toggleShippingMsg();

			const selector = document.querySelector('.doubly-nice-select');
			if (selector !== null) {
				new MutationObserver(async () => {
					this.cart = await (await fetch('/cart.js')).json();
					this.toggleShippingMsg();
				}).observe(selector, { attributes: true, subtree: true });
			}

			document.addEventListener('cart:updated', evt => {
				this.cart = evt.detail.cart;
				this.toggleShippingMsg();
			});

			document.addEventListener('ajaxProduct:added', async () => {
				this.cart = await (await fetch('/cart.js')).json();
				this.toggleShippingMsg();
			});
		};
		isCheckVariable();
	};

	toggleShippingMsg() {
		this.target.innerHTML = '';

		if (Shopify.locale === 'ja' && DoublyGlobalCurrency.currentCurrency === 'JPY') {
			this.target.classList.remove('hide');

			const { total_price } = this.cart;          
			if (total_price > this.amount) {
				this.target.innerHTML = `<b>${this.success_msg}</b>`;
				return;
			}

			this.target.innerHTML = this.msg.replace('****', `<b>${theme.Currency.formatMoney(this.amount - total_price)}</b>`);
			return;
		}

		this.target.classList.add('hide');
	};
};

document.addEventListener('DOMContentLoaded', () => {
	CI.customProductTags = new customProductTags;
	CI.bundledControl = new bundledControl;
	CI.purchaseLimit = new purchaseLimit;
});

window.addEventListener('load', () => {
	CI.freeShipping = new freeShipping;
});